import {
  ApiSchemaName,
  useMetadataInfiniteApi,
} from './useMetadataInfiniteApi';

export const useMetadataStructuredApi = (schemaName: ApiSchemaName) => {
  const api = useMetadataInfiniteApi();

  const flatData = api.data?.pages?.flat(1);

  const data = flatData?.find(
    item => item.metadata.schemaName === schemaName
  )?.metadata;

  return {
    ...api,
    data,
  };
};
